import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { Container } from 'reactstrap';
import { injectIntl } from 'react-intl';

import { APIgetPages } from '../../api/Pages';

import AdminPagesHeader from '../../components/Admin/Pages/Header';
import AdminPagesList from '../../components/Admin/Pages/List';
import AdminPagesFooter from '../../components/Admin/Pages/Footer';
import TrialNotice from '../../components/TrialNotice';
import EmptyCustomPages from '../EmptyContainers/CustomPages';

import { getVisibleItemsText } from '../../helpers';
import { getUserSetting } from '../../helpers/Settings';
import { addFlashMessage } from '../../helpers/FlashMessages';
import {
  handleComponentParams,
  handleURLParams,
} from '../../helpers/URLParams';

import Loading from '../../components/Loading';
import ErrorBoundary from '../../components/ErrorBoundary';

class AdminPages extends Component {
  constructor(props) {
    super(props);

    this.state = {
      pages: [],
      pagesTotal: 0,
      page: 1,
      perPage: getUserSetting('admin_per_page') || 20,
      orderBy: 'name',
      order: 'asc',
      loading: true,
    };

    this.handleChangeOrder = this.handleChangeOrder.bind(this);
    this.handleChangePage = this.handleChangePage.bind(this);
    this.handleChangePerPage = this.handleChangePerPage.bind(this);
    this.loadPages = this.loadPages.bind(this);
    this.deletePageFromList = this.deletePageFromList.bind(this);
  }

  componentDidMount() {
    const { history, location } = this.props;
    const { orderBy, order } = this.state;
    const queryParams = new URLSearchParams(location.search);

    handleComponentParams(
      true,
      ['orderBy', 'order', 'page', 'perPage'],
      null,
      this.setState.bind(this),
      () => this.loadPages(),
      { orderBy: 'name', order: 'asc', perPage: getUserSetting('admin_per_page') || 20 },
    );

    if (!queryParams.get('orderBy')) {
      handleURLParams({ orderBy }, history);
    }

    if (!queryParams.get('order')) {
      handleURLParams({ order }, history);
    }
  }

  componentDidUpdate(prevProps) {
    handleComponentParams(
      false,
      ['orderBy', 'order', 'page', 'perPage'],
      prevProps,
      this.setState.bind(this),
      () => this.loadPages(),
      { orderBy: 'name', order: 'asc', perPage: getUserSetting('admin_per_page') || 20 },
    );
  }

  loadPages(silent = false) {
    const {
      page,
      perPage,
      orderBy,
      order,
    } = this.state;

    if (!silent) {
      this.setState({ loading: true });
    }

    APIgetPages({
      page,
      per_page: perPage,
      order_by: orderBy,
      order,
    }).then((response) => {
      const { data } = response;
      if (data) {
        this.setState({
          loading: false,
          pages: data.data,
          pagesTotal: data.meta.total,
        });
      }
    });
  }

  deletePageFromList(page) {
    const { intl } = this.props;

    this.setState(prevState => ({
      pages: prevState.pages.filter(p => (p.id !== page.id)),
    }));
    addFlashMessage({
      type: 'success',
      text: intl.formatMessage({
        defaultMessage: 'Page has been deleted',
      }),
    });
    this.loadPages(true);
  }

  handleChangeOrder(orderBy, order) {
    const { history } = this.props;
    handleURLParams({ orderBy, order, page: 1 }, history);

    this.setState({
      orderBy,
      order,
      page: 1,
    });
  }

  handleChangePage(page) {
    const { history } = this.props;
    handleURLParams({ page }, history);

    this.setState({ page });
  }

  handleChangePerPage(perPage) {
    const { history } = this.props;
    handleURLParams({ perPage, page: 1 }, history);

    this.setState({ perPage, page: 1 });
  }

  render() {
    const {
      intl,
    } = this.props;
    const {
      page,
      perPage,
      pagesTotal,
      loading,
    } = this.state;

    return (
      <div className="main-content custom-pages-content">
        <Container fluid>
          <AdminPagesHeader
            pagesTotal={pagesTotal}
            pagesVisible={getVisibleItemsText(page, perPage, pagesTotal)}
            loading={loading}
          />
          <TrialNotice feature="custom-pages" />
          {pagesTotal > 0 && (
            <div className="content-wrapper">
              <p>
                {intl.formatMessage({ defaultMessage: 'Create and manage your Content Portals.' })}
              </p>
            </div>
          )}
          {loading ? (
            <Loading />
          ) : (
            <div className="content-wrapper">
              {pagesTotal > 0 ? (
                <>
                  <ErrorBoundary>
                    <AdminPagesList
                      {...this.state}
                      loadPages={this.loadPages}
                      handleChangeOrder={this.handleChangeOrder}
                      deletePageFromList={this.deletePageFromList}
                    />
                  </ErrorBoundary>
                  <ErrorBoundary>
                    <AdminPagesFooter
                      {...this.state}
                      handleChangePage={this.handleChangePage}
                      handleChangePerPage={this.handleChangePerPage}
                    />
                  </ErrorBoundary>
                </>
              ) : (
                <EmptyCustomPages />
              )}
            </div>
          )}
        </Container>
      </div>
    );
  }
}

AdminPages.propTypes = {
  intl: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
};

export default withRouter(injectIntl(AdminPages));
